import { z } from "zod";

import { monthlyAuditDate } from "@/schemas";

export const hudChecklistSchema = z.object({
  auditDate: monthlyAuditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  filterChangeDate: z.date().refine((val) => val <= new Date(), {
    message: "Date cannot be in future",
  }),
  waterHeater: z
    .boolean()
    .refine((val) => val, { message: "Check is required" }),
  waterHeaterDrained: z
    .boolean()
    .refine((val) => val, { message: "Check is required" }),
  plumbing: z.boolean().refine((val) => val, { message: "Check is required" }),
  hvac: z.boolean().refine((val) => val, { message: "Check is required" }),
  breakerBox: z
    .boolean()
    .refine((val) => val, { message: "Check is required" }),
  exhaustFan: z
    .boolean()
    .refine((val) => val, { message: "Check is required" }),
  appliances: z
    .boolean()
    .refine((val) => val, { message: "Check is required" }),
  buildingErosion: z
    .boolean()
    .refine((val) => val, { message: "Check is required" }),
  buildingVegetation: z
    .boolean()
    .refine((val) => val, { message: "Check is required" }),
  buildingSiding: z
    .boolean()
    .refine((val) => val, { message: "Check is required" }),
  gutterCleanDate: z.date(),
  gutterClear: z
    .boolean()
    .refine((val) => val, { message: "Check is required" }),
  trashAreaInspected: z
    .boolean()
    .refine((val) => val, { message: "Check is required" }),
  walkwayClear: z
    .boolean()
    .refine((val) => val, { message: "Check is required" }),
  yardUpkeep: z
    .boolean()
    .refine((val) => val, { message: "Check is required" }),
  carpetClean: z
    .boolean()
    .refine((val) => val, { message: "Check is required" }),
  mechanicalRoomDate: z.date().refine((val) => val <= new Date(), {
    message: "Date cannot be in future",
  }),
  laundryRoomInspected: z
    .boolean()
    .refine((val) => val, { message: "Check is required" }),
  fireAlarm: z.boolean().refine((val) => val, { message: "Check is required" }),
  carbonMonoDetector: z
    .boolean()
    .refine((val) => val, { message: "Check is required" }),
  extinguisher: z
    .boolean()
    .refine((val) => val, { message: "Check is required" }),
  extinguisherTagDate: z.date().refine((val) => val <= new Date(), {
    message: "Date cannot be in future",
  }),
  caulking: z.boolean().refine((val) => val, { message: "Check is required" }),
  bedBugs: z.boolean().refine((val) => val, { message: "Check is required" }),
  windows: z.boolean().refine((val) => val, { message: "Check is required" }),
  fireAlarmCheckDate: z.date().refine((val) => val <= new Date(), {
    message: "Date cannot be in future",
  }),
  pestControlExamDate: z.date().refine((val) => val <= new Date(), {
    message: "Date cannot be in future",
  }),
  yardContractDate: z.date().refine((val) => val <= new Date(), {
    message: "Date cannot be in future",
  }),
  issues: z.array(z.string().optional()).optional(),
});
